import { NICmsContentComponent } from '@icms/core/content';
import { NCmsBlogCategory } from '../../blog/category/cms-blog-category.interface';
import { NCmsBlogPost } from '../../blog/post/cms-blog-post.interface';
import { NCmsBlogRoot } from '../../blog/root/cms-blog-root.interface';

export namespace NCmsComponentListing {
    export const ID = 'listing';

    export interface IData extends NICmsContentComponent.IData {
        type: 'product' | 'page' | 'category' | 'store';
        matching: 'pageType' | 'group' | 'custom';
        pageType?: typeof NCmsBlogCategory.typeId | typeof NCmsBlogPost.typeId | typeof NCmsBlogRoot.typeId;
        rule?: string;
        group?: number;
        colspan: number;
        limit?: string;
        sort?: string;
        verbosity?: 1 | 2 | 3 | 4;
        initialStepsVisible?: number;
        infScrollStep?: number;
    }
}
